import React, { Suspense, useEffect, useRef, useState } from 'react'
import { Canvas, useFrame, useLoader } from '@react-three/fiber'
import { useGLTF, OrbitControls, Environment, useAnimations, Plane } from '@react-three/drei'
import { Color } from 'three'
import TrailSelection from './TrailSelection'
import TrailComponent from './TrailComponent'
import { Effects } from './Effects'
import FireTrail from './FireTrail'
import EthTrail from './EthTrail'
import DollarTrail from './DollarTrails'
import ElectricTrail from './ElectricTrail'
import CircuitTrail from './CircuitTrail'
import PlasmaTrail from './PlasmaTrail'
import BlueTrail from './BlueTrail'
import RedTrail from './RedTrail'
import RainbowTrail from './RainbowTrail'
import RainbowTrail2 from './RainbowTrail2'
import SmokeTrail from './SmokeTrail'
import ShardTrail from './ShardsTrails'
import ColdPlasmTrail from './ColdPlasmTrail'
import CharTrail from './CharTrail'
import { TextureLoader } from 'three'
import { RepeatWrapping } from 'three'

const trailsData = [
  { name: 'Char', imgSrc: '/fire_trail.png', component: CharTrail },
  { name: 'Smoke', imgSrc: '/smoke_trail.png', component: SmokeTrail },
  { name: 'Fire', imgSrc: '/fire_trail.png', component: FireTrail },
  { name: 'Electric', imgSrc: '/electric_trail.png', component: ElectricTrail },
  { name: 'Plasma', imgSrc: '/plasma_trail.png', component: PlasmaTrail },
  { name: 'Rainbow', imgSrc: '/rainbow_trail.png', component: RainbowTrail },
  { name: 'Rainbow2', imgSrc: '/rainbow_trail2.png', component: RainbowTrail2 },
  { name: 'Circuit', imgSrc: '/circuit_trail.png', component: CircuitTrail },
  { name: 'BlueTrail', imgSrc: '/blue_trail.png', component: BlueTrail },
  { name: 'DollarTrail', imgSrc: '/dollar.png', component: DollarTrail },
  { name: 'EthTrail', imgSrc: '/eth.png', component: EthTrail },
  { name: 'ShardTrail', imgSrc: '/shard_trail.png', component: ShardTrail },
  { name: 'RedTrail', imgSrc: '/red_trail.png', component: RedTrail },
  { name: 'ColdPlasmTrail', imgSrc: '/cold_plasm_trail.png', component: ColdPlasmTrail }
]

export default function App() {
  const [selectedTrail, setSelectedTrail] = useState('Char') // Default trail
  const bikeColor = new Color('green')
  const [myMaterial, setMaterial] = useState({})

  const handleTrailSelect = (trail) => {
    setSelectedTrail(trail)
  }

  return (
    <>
      <TrailSelection trailsData={trailsData} selectedTrail={selectedTrail} onSelectTrail={handleTrailSelect} />

      <Canvas
        style={{
          height: '100vh'
        }}
        gl={{
          antialias: false,
          stencil: false
        }}
        camera={{ position: [2, 2, 0], fov: 80 }}>
        {/* <ambientLight intensity={1} /> */}
        <Track position={[-80, 0, 0]} scale={[1, 1.0, 1.2]} />

        <BikeModel myMaterial={myMaterial} bikeColor={bikeColor} position={[0, 0.2, 1]} rotation={[0, Math.PI, 0]} scale={1} />
        <Environment files="/shanghai_bund_1k.hdr" />
        <ambientLight intensity={0.1} />
        <directionalLight intensity={1} position={[5, 5, 5]} castShadow shadow-mapSize-width={1024} shadow-mapSize-height={1024} shadow-bias={-0.003} />
        {trailsData.map((trailInfo) => (
          <TrailComponent
            setMaterial={setMaterial}
            bikeColor={bikeColor}
            trailsData={trailsData}
            key={trailInfo.name}
            selected={selectedTrail === trailInfo.name}
            onClick={() => handleTrailSelect(trailInfo.name)}
            {...trailInfo}
          />
        ))}

        {/* <PointLightComponent position={[0, 0, 0]} /> */}

        <Effects />
        <OrbitControls />
      </Canvas>
    </>
  )
}

function Track({ ...props }) {
  const { scene, materials, animations } = useGLTF('/purple_city_track.glb')
  const floorTexture = useLoader(TextureLoader, '/scifi_floor.png')
  floorTexture.wrapS = RepeatWrapping
  floorTexture.wrapT = RepeatWrapping
  const { actions } = useAnimations(animations, scene)
  const mat_ref = useRef()
  useEffect(() => {
    animations.forEach((a) => actions[a.name]?.play())
    console.log(animations)
    console.log(actions)
  }, [])
  useFrame(() => {
    if (mat_ref.current) {
      // mat_ref.current.map.offset.x = mat_ref.material.offset.x + 0.01
      if (mat_ref.current.map.offset) {
        mat_ref.current.map.repeat.set(2, 2) // You can adjust the repeat factor as needed

        mat_ref.current.map.offset.x = mat_ref.current.map.offset.x - 0.001 // - Math.floor(mat_ref.current.map.offset.x + 0.001)
        // mat_ref.current.map.offset.y += .0001
      }
      // console.log(mat_ref.current.map.offset.x)
    }
  })

  return (
    <group>
      <primitive castShadow={true} object={scene} {...props} />
      <Plane scale={100} rotation={[Math.PI / 2, 0, 0]} position={[-40, -4.75, 0]}>
        <meshPhongMaterial ref={mat_ref} map={floorTexture} side={2} />
      </Plane>
    </group>
  )
}

function StartLine({ ...props }) {
  const { scene } = useGLTF('/starter_line.glb')
  return (
    <group {...props}>
      <primitive object={scene} />
    </group>
  )
}

function BikeModel({ myMaterial, bikeColor, ...props }) {
  const { scene, materials } = useGLTF('/tron_v11.glb')

  const modelRef = useRef()
  const updateTrail = () => {
    if (modelRef.current) {
      // console.log(materials);
      const material = materials['glow_blue.001']
      material.emissive = bikeColor
      material.emissiveIntensity = 1.0
      material.color = bikeColor

      if (myMaterial) materials['glow_blue.001'] = myMaterial
    }
  }

  useFrame(() => {
    updateTrail()
  })
  return (
    <group>
      <primitive castShadow={true} ref={modelRef} object={scene} {...props} />
    </group>
  )
}
